// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1wBnQ","options":"AnswerScale_options__2Fi30","selected":"AnswerScale_selected__3ddZ0"};